import React, { useState, useEffect, useRef } from 'react';
import { Bell, Filter, LogOut, ChevronDown, Map, Download, Eye, Trash2, MoreVertical, CheckCircle, XCircle, Sliders, Search, TrendingUp, ChevronLeft, ChevronRight
  
 } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import BiogasBarChart from './BiogasBarChart';
import MapComponent from './MapComponent';
import { motion, AnimatePresence } from 'framer-motion';
import ReportSection from './Report';  // Importing the Report component
import DeviceDashboard from './DeviceDashboard';
import SuperAdminSidebar from './SuperAdminSidebar';
const SMain=()=>{
  
    const [isExpanded, setIsExpanded] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');
  const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [unreadCount, setUnreadCount] = useState(0);
    const [mapView, setMapView] = useState(true);
    const [loading, setLoading] = useState(true);
    const [bioReactorModel, setBioReactorModel] = useState(null);
    const [activePage, setActivePage] = useState('dashboard'); // 'dashboard', 'reports'
    const [currentPage, setCurrentPage] = useState(1);

    const [selectedDevice, setSelectedDevice] = useState(null);
    const [deviceInfoModal, setDeviceInfoModal] = useState(false);
    // Stats data
    const stats = [
      {
        id: 1,
        title: "Total Devices",
        value: "7",
        icon: <div className="bg-blue-100 p-3 rounded-full"><img src="/Assets/chip.png" alt="Devices" className="h-6 w-6" /></div>,
        change: "+12%"
      },
      {
        id: 2,
        title: "Active Devices",
        value: "4",
        icon: <div className="bg-green-100 p-3 rounded-full"><CheckCircle className="h-6 w-6 text-green-500" /></div>,
        change: "+5%"
      },
      {
        id: 3,
        title: "Biogas Production",
        value: "1,284 m³",
        icon: <div className="bg-amber-100 p-3 rounded-full"><img src="/Assets/gas.svg" alt="Biogas" className="h-6 w-6" /></div>,
        change: "+3.2%"
      },
      {
        id: 4,
        title: "Carbon Offset",
        value: "846 kg",
        icon: <div className="bg-teal-100 p-3 rounded-full"><img src="/Assets/co2.svg" alt="Carbon" className="h-6 w-6" /></div>,
        change: "+7.1%"
      }
    ];
    const handleBackToDashboard = () => {
      setActivePage('dashboard');
    };
    const handleDeviceInfoSubmit = () => {
      // Handle device info submission logic here
      console.log('Device info submitted:', selectedDevice);
      setDeviceInfoModal(false);
    };
       // Summary card content
  const summaryContent = {
    title: "Biogas Plant Overview",
    description: "Sustainable energy generation tracking system.",
    highlights: [
      "Optimizing renewable energy production",

    ]
  };
  
  const products = [
    { id: "HW-1", status: "online", client: "Prathaban", clientAvatar: "male.png", location: "Chennai, India", lastUpdated: "28/10/2024" },
    { id: "HW-2", status: "online", client: "Viji", clientAvatar: "female.png", location: "Mumbai, India", lastUpdated: "28/10/2024" },
    { id: "HW-3", status: "offline", client: "Muthuraja", clientAvatar: "male2.png", location: "Delhi, India", lastUpdated: "27/10/2024" },
    { id: "HW-4", status: "online", client: "Varshana", clientAvatar: "female2.png", location: "Bangalore, India", lastUpdated: "28/10/2024" },
    { id: "HW-5", status: "offline", client: "Robin", clientAvatar: "man.png", location: "Kolkata, India", lastUpdated: "27/10/2024" },
    { id: "HW-6", status: "online", client: "Jerin", clientAvatar: "male.png", location: "Hyderabad, India", lastUpdated: "28/10/2024" },
    { id: "HW-7", status: "offline", client: "Sujith", clientAvatar: "male2.png", location: "Pune, India", lastUpdated: "27/10/2024" }
  ];


  const filteredProducts = products.filter(product => {
    const matchesSearch = 
      product.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.client.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.location.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesStatus = statusFilter === 'All' || product.status === statusFilter.toLowerCase();
    
    return matchesSearch && matchesStatus;
  });
  const handleViewDevice = (product) => {
    setSelectedDevice(product);
    // Optionally, you can keep the current page as 'dashboard'
    setActivePage('dashboard');
  };


  const handleDeviceSettings = (device) => {
    setSelectedDevice(device);
    setDeviceInfoModal(true);
  };


    return (
      <div className="min-h-screen p-3 md:p-6">
      {activePage === 'dashboard' && !selectedDevice && (
        <>
          {/* Stats Section - Responsive Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-6 mb-5">
            {/* Summary Card - Full width on mobile, 3 columns on large screens */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="col-span-1 lg:col-span-3 bg-white rounded-lg shadow-md p-4 md:p-6"
            >
              <h2 className="text-lg md:text-xl font-bold mb-2 md:mb-4 text-gray-800">{summaryContent.title}</h2>
              <p className="text-sm md:text-base text-gray-600 mb-2 md:mb-4">{summaryContent.description}</p>
              <div className="space-y-1 md:space-y-2">
                {summaryContent.highlights.map((highlight, index) => (
                  <div key={index} className="flex items-center text-xs md:text-sm text-gray-700">
                    <CheckCircle className="h-3 w-3 md:h-4 md:w-4 mr-1 md:mr-2 text-green-500" />
                    {highlight}
                  </div>
                ))}
              </div>
            </motion.div>

            {/* Stats Grid - Full width on mobile, 9 columns on large screens */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="col-span-1 lg:col-span-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6"
            >
              {stats.map((stat, index) => (
                <motion.div
                  key={stat.id}
                  initial={{ y: 50, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.5, delay: index * 0.1 + 0.3 }}
                  whileHover={{ y: -5, boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)" }}
                  className="bg-white rounded-lg shadow-md p-4 md:p-6 flex items-center"
                >
                  <div className="hidden sm:block">{stat.icon}</div>
                  <div className="ml-0 sm:ml-5">
                    <p className="text-xs md:text-sm text-gray-500 font-medium">{stat.title}</p>
                    <p className="text-xl md:text-2xl font-bold text-gray-800">{stat.value}</p>
                    <p className="text-xs text-green-600 mt-1 flex items-center">
                      <span>↑</span> {stat.change} this week
                    </p>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </div>

          {/* Title and View Toggle - Improved Mobile Layout */}
          <div className="mb-4 md:mb-6 flex flex-col sm:flex-row sm:justify-between sm:items-center space-y-3 sm:space-y-0">
            <motion.h2
              initial={{ x: -50, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.5 }}
              className="text-xl md:text-2xl font-bold text-gray-800"
            >
              Products
            </motion.h2>
            <motion.div
              initial={{ x: 50, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.5 }}
              className="flex space-x-3"
            >
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className={`px-3 md:px-4 py-2 rounded-md flex items-center text-sm md:text-base ${
                  mapView
                    ? 'bg-teal-600 text-white'
                    : 'bg-white text-gray-700 border border-gray-300'
                }`}
                onClick={() => setMapView(!mapView)}
              >
                <Map size={16} className="mr-1 md:mr-2" />
                {mapView ? 'Table View' : 'Map View'}
              </motion.button>
            </motion.div>
          </div>

          {/* Map View with 3D model section - Stack on mobile, side by side on larger screens */}
          <AnimatePresence>
            {mapView && (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 20 }}
                transition={{ duration: 0.5 }}
                className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-6"
              >
                {/* Map Section */}
                <motion.div
                  initial={{ x: -50, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  className="bg-white rounded-lg shadow-md p-4"
                >
                  <div className="h-64 md:h-96 bg-gray-200 rounded-lg flex items-center justify-center">
               <MapComponent products={products} onSelectDevice={handleViewDevice} />
                  </div>
                </motion.div>

                {/* Chart Section */}
                <motion.div
                  initial={{ y: 50, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.5, delay: 0.4 }}
                  className="bg-white rounded-lg shadow-md p-4"
                >
                  <h2 className="text-lg md:text-xl font-semibold mb-4">Biogas Production</h2>
                  <BiogasBarChart isExpanded={isExpanded} />
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>

          {/* Table Controls - Improved Mobile Layout */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden mb-6">
            <div className="p-3 md:p-4 border-b border-gray-200 flex flex-col sm:flex-row sm:justify-between gap-3 md:gap-4">
              {/* Top row for mobile, left side for desktop */}
              <div className="flex flex-wrap items-center gap-3">
                <div className="flex items-center space-x-2">
                  <label htmlFor="entriesPerPage" className="text-xs md:text-sm text-gray-600">Show</label>
                  <select
                    id="entriesPerPage"
                    className="border border-gray-300 rounded-md px-1 md:px-2 py-1 text-xs md:text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
                    value={entriesPerPage}
                    onChange={(e) => setEntriesPerPage(Number(e.target.value))}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={30}>30</option>
                  </select>
                  <span className="text-xs md:text-sm text-gray-600">entries</span>
                </div>

                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="bg-teal-600 text-white px-3 md:px-4 py-1 md:py-2 text-xs md:text-sm rounded-md flex items-center"
                  onClick={() => setActivePage('reports')}
                >
                  View Reports
                </motion.button>
              </div>

              {/* Bottom row for mobile, right side for desktop */}
              <div className="flex flex-wrap items-center gap-3">
                <div className="relative flex-grow max-w-full sm:max-w-xs">
                  <Search
                    className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                    size={16}
                  />
                  <input
                    type="text"
                    placeholder="Search Hardware"
                    className="w-full pl-10 pr-3 py-1 md:py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-500 text-xs md:text-sm"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>

                <select
                  className="border border-gray-300 rounded-md px-2 md:px-3 py-1 md:py-2 focus:outline-none focus:ring-2 focus:ring-teal-500 text-xs md:text-sm"
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <option value="All">All Status</option>
                  <option value="Online">Online</option>
                  <option value="Offline">Offline</option>
                </select>
              </div>
            </div>

            {/* Products Table with Horizontal Scroll for Small Screens */}
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th scope="col" className="px-3 md:px-6 py-2 md:py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      <span className="sr-only">Serial</span>
                    </th>
                    <th scope="col" className="px-3 md:px-6 py-2 md:py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Product ID
                    </th>
                    <th scope="col" className="px-3 md:px-6 py-2 md:py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Status
                    </th>
                    <th scope="col" className="px-3 md:px-6 py-2 md:py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Client
                    </th>
                    <th scope="col" className="hidden md:table-cell px-3 md:px-6 py-2 md:py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Location
                    </th>
                    <th scope="col" className="hidden md:table-cell px-3 md:px-6 py-2 md:py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Last Updated
                    </th>
                    <th scope="col" className="px-3 md:px-6 py-2 md:py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {filteredProducts.map((product, index) => (
                    <tr key={product.id} className="hover:bg-gray-50">
                      <td className="px-3 md:px-6 py-2 md:py-4 whitespace-nowrap">
                        <div className="text-xs md:text-sm font-medium text-gray-900">
                          {index + 1}
                        </div>
                      </td>
                      <td className="px-3 md:px-6 py-2 md:py-4 whitespace-nowrap">
                        <div className="text-xs md:text-sm font-medium text-gray-900">
                          {product.id}
                        </div>
                      </td>
                      <td className="px-3 md:px-6 py-2 md:py-4 whitespace-nowrap">
                        <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${
                          product.status === 'online'
                            ? 'bg-green-100 text-green-800'
                            : 'bg-red-100 text-red-800'
                        }`}>
                          {product.status}
                        </span>
                      </td>
                      <td className="px-3 md:px-6 py-2 md:py-4 whitespace-nowrap">
                        <div className="text-xs md:text-sm text-gray-900">
                          {product.client}
                        </div>
                      </td>
                      <td className="hidden md:table-cell px-3 md:px-6 py-2 md:py-4 whitespace-nowrap text-xs md:text-sm text-gray-500">
                        {product.location}
                      </td>
                      <td className="hidden md:table-cell px-3 md:px-6 py-2 md:py-4 whitespace-nowrap text-xs md:text-sm text-gray-500">
                        {product.lastUpdated}
                      </td>
                      <td className="px-3 md:px-6 py-2 md:py-4 whitespace-nowrap text-xs md:text-sm font-medium">
                        <div className="flex space-x-2 md:space-x-3">
                          <button 
                            onClick={() => handleViewDevice(product)}
                            className="text-teal-600 hover:text-teal-900"
                          >
                            <Eye size={16} />
                          </button>
                          <button 
                            onClick={() => handleDeviceSettings(product)}
                            className="text-gray-500 hover:text-gray-700"
                          >
                            <MoreVertical size={16} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination - Responsive Layout */}
            <div className="px-3 md:px-6 py-3 md:py-4 flex flex-col sm:flex-row sm:items-center sm:justify-between border-t border-gray-200 gap-2">
              <div className="text-xs md:text-sm text-gray-700">
                Showing <span className="font-medium">1</span> to{' '}
                <span className="font-medium">
                  {Math.min(entriesPerPage, filteredProducts.length)}
                </span>{' '}
                of{' '}
                <span className="font-medium">{filteredProducts.length}</span> results
              </div>
              <div className="flex justify-center sm:justify-end">
                <nav
                  className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
                  aria-label="Pagination"
                >
                  <button
                    className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                    onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                  >
                    <span className="sr-only">Previous</span>
                    <ChevronLeft size={16} />
                  </button>
                  <button
                    className={`relative inline-flex items-center px-3 md:px-4 py-2 border border-gray-300 text-sm font-medium ${
                      currentPage === 1 ? 'bg-teal-50 text-teal-600' : 'bg-white text-gray-700 hover:bg-gray-50'
                    }`}
                    onClick={() => setCurrentPage(1)}
                  >
                    1
                  </button>
                  <button
                    className={`relative inline-flex items-center px-3 md:px-4 py-2 border border-gray-300 text-sm font-medium ${
                      currentPage === 2 ? 'bg-teal-50 text-teal-600' : 'bg-white text-gray-700 hover:bg-gray-50'
                    }`}
                    onClick={() => setCurrentPage(2)}
                  >
                    2
                  </button>
                  <button
                    className={`relative hidden md:inline-flex items-center px-3 md:px-4 py-2 border border-gray-300 text-sm font-medium ${
                      currentPage === 3 ? 'bg-teal-50 text-teal-600' : 'bg-white text-gray-700 hover:bg-gray-50'
                    }`}
                    onClick={() => setCurrentPage(3)}
                  >
                    3
                  </button>
                  <button
                    className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                    onClick={() => setCurrentPage(Math.min(3, currentPage + 1))}
                  >
                    <span className="sr-only">Next</span>
                    <ChevronRight size={16} />
                  </button>
                </nav>
              </div>
            </div>
          </div>
        </>
      )}

      {activePage === 'dashboard' && selectedDevice && (
        <DeviceDashboard 
          product={selectedDevice} 
          onBackToDeviceList={() => setSelectedDevice(null)} 
        />
      )}

      {activePage === 'reports' && (
        <ReportSection onBackToDashboard={handleBackToDashboard} />
      )}

      {/* Modal with Responsive Design */}
      {deviceInfoModal && selectedDevice && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white p-4 md:p-6 rounded-lg w-full max-w-sm md:max-w-md">
            <h2 className="text-lg md:text-xl font-bold mb-4">Device Information</h2>
            <div className="mb-4">
              <label className="block text-gray-700 font-medium mb-2 text-sm md:text-base">Device ID</label>
              <input 
                type="text" 
                value={selectedDevice.id} 
                readOnly 
                className="w-full px-3 py-2 border rounded bg-gray-100 text-sm md:text-base"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 font-medium mb-2 text-sm md:text-base">Status</label>
              <select 
                className="w-full px-3 py-2 border rounded text-sm md:text-base"
                defaultValue={selectedDevice.status}
              >
                <option value="enable">Enable</option>
                <option value="disable">Disable</option>
              </select>
            </div>
            <div className="flex justify-end space-x-2">
              <button 
                onClick={() => setDeviceInfoModal(false)}
                className="px-3 md:px-4 py-1 md:py-2 bg-gray-200 rounded text-sm md:text-base"
              >
                Cancel
              </button>
              <button 
                onClick={handleDeviceInfoSubmit}
                className="px-3 md:px-4 py-1 md:py-2 bg-teal-600 text-white rounded text-sm md:text-base"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>

    );
}
export default SMain;